import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownEducationStatus = ({ control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly } ) =>
{
    const mapFn = ( record )  =>
    {
        return {
            education_status_id: +record.education_status_id,
            es_description: record.es_description,
            es_type: +record.es_type
        }
    }

    const [ loading, items ] = useListboxFetch( { url: '/educationstatus', keyFieldName: 'education_status_id', labelFieldName: 'es_description', additionalFields: ['es_type'], mapFn: mapFn } ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownEducationStatus;
